import { render, staticRenderFns } from "./rowNavigationDrawer.vue?vue&type=template&id=88993fb6&scoped=true"
import script from "./rowNavigationDrawer.vue?vue&type=script&lang=ts"
export * from "./rowNavigationDrawer.vue?vue&type=script&lang=ts"
import style0 from "./rowNavigationDrawer.vue?vue&type=style&index=0&id=88993fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88993fb6",
  null
  
)

export default component.exports